import { render } from "./AvatarMenu.vue?vue&type=template&id=39a2526f&scoped=true"
import script from "./AvatarMenu.vue?vue&type=script&lang=js"
export * from "./AvatarMenu.vue?vue&type=script&lang=js"

import "./AvatarMenu.vue?vue&type=style&index=0&id=39a2526f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a2526f"]])

export default __exports__